export default class FileUploadService {
    constructor(serverContext) {
        this.serverContext = serverContext;
    }
    async uploadFile(file, category, id = null, comment = '') {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('category', category);
        if (id) {
            formData.append('id', id);
        }
        if (comment) {
            formData.append('comment', comment);
        }

        const response = await this.serverContext.files.upload(formData);

        if (response.error !== 'OK') {
            throw new Error(response.error);
        }

        return response.data;
    }

    async downloadFile(fileUuid, downloadMethod = 'token') {
        // old:
        // if (!fileName) {
        //     this.setState({ alertError: 'File is not found.' });
        //     return;
        // }
        // const res = this.context.getState().server.files.getFile(fileName);
        // res.then((response) => {
        //     const url = URL.createObjectURL(response.data);
        //     window.open(url);
        // });
        // new downlaod:
        //     1) by jwt token:
        // {{Cabinet_server}}/api/files/download/token/eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJmaWxlVG9rZW4iLCJleHAiOjE3NTg5MDUxOTIsInBhcmFtcyI6IntcInV1aWRcIjpcIjUxYjY2NWM4LTYyMmYtNDVkZC1hMTE4LTVmMzM5YjE3MTM4OVwifSJ9.Xeb7CV3wdUUEZO-CCwU2i6GYcpLyJdppcmd5H4B5kAivuCF4Z8chuA-HBvpKWr2_X7z4G3TFIHZ8XewIvGTLqqPYkqDwcbFH1uG6TKv_MEMTDkl31uFHVRQTRD7CX-dzl9EB6haliGNiLPRJHSMWTIbfIac3WjvnNlCYgxwrHrJZU0qXiX0De9YNe0voBJ0spKbjmlQB7EfWX7K-l3EjVSICW9kll239w8QfInHLdK0VKRne0MUtAHEgqf203K7L1jxmh22HdcmkcZGY-MuiDUCsYtcrAgdLvwoFsN7F_swi78S7x2izIf_hkEwHM-yehbkx6b4WQjpXF9DS6kDzUA
        //
        // by file uuid:
        // {{Cabinet_server}}/api/files/download/uuid/c3a3067c-efbd-4270-aac3-f851e75bec03
        // both work without authentication
        //
        // get token by file uuid:
        // {{Cabinet_server}}/api/files/token/51b665c8-622f-45dd-a118-5f339b171389
        // (only for accessible category files)
        let downloadResp;
        if (downloadMethod === 'uuid') {
            downloadResp = await this.getFileByUuid(fileUuid);

        } else {
            return await this.getFileWithToken(fileUuid);

        }
        console.log('downloadResp', downloadResp);
    }
    async getFileWithToken(fileUuid) {
        const tokenResp = await this.serverContext.files.getTokenByUuid(fileUuid);
        if (tokenResp.error !== 'OK') {
            throw new Error(tokenResp.error);
        }
        return this.serverContext.files.openByTokenInNewTab(tokenResp.data);
    }
    async getFileByUuid(fileUuid) {
        const downloadResp = await this.serverContext.files.downloadByUuid(fileUuid);
        if (downloadResp.error !== 'OK') {
            throw new Error(downloadResp.error);
        }
        return downloadResp.data;
    }
}


